"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var group_info_1 = require("./group-info");
var plugged_control_1 = require("./plugged-control");
var PluggedControlsModel = /** @class */ (function () {
    function PluggedControlsModel() {
    }
    PluggedControlsModel.prototype.createTreeFromControls = function (metaControls) {
        var ungrouped = new group_info_1.GroupInfo({ identity: 'ungrouped', name: 'ungrouped' }, []);
        var groups = [ungrouped];
        metaControls.forEach(function (metaControl) {
            if (metaControl.groups !== undefined) {
                metaControl.groups.forEach(function (controlGroup) {
                    var groupInfo = groups.find(function (group) { return group.group.identity === controlGroup.identity; });
                    if (groupInfo === undefined) {
                        groups.push(new group_info_1.GroupInfo(controlGroup, [new plugged_control_1.PluggedControl(metaControl)]));
                    }
                    else {
                        groupInfo.controls.push(new plugged_control_1.PluggedControl(metaControl));
                    }
                });
            }
            else {
                ungrouped.controls.push(new plugged_control_1.PluggedControl(metaControl));
            }
        });
        this.groups = groups;
        return this;
    };
    return PluggedControlsModel;
}());
exports.PluggedControlsModel = PluggedControlsModel;
//# sourceMappingURL=plugged-controls.model.js.map